export default function NotFound() {
  return (
    <div>
      <h3>
        <span>No match for </span>
        <code>{location.pathname}</code>
      </h3>

      <p>{`window.location.href: ${window.location.href}`}</p>
      <p>{`window.location.hostname : ${window.location.hostname}`}</p>
      <p>{`window.location.pathname : ${window.location.pathname}`}</p>
      <p>{`window.location.protocol : ${window.location.protocol}`}</p>

      <p>{`split pathname : ${window.location.pathname.split('/')}`}</p>

      <p>{`href replace : ${location.href.replace(/[^/]*$/, '')}`}</p>

      <p>{`pathname replace : ${location.pathname.replace(/[^/]*$/, '')}`}</p>
    </div>
  );
}
